<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="LS01_background">
        <div class="position">
          <div style="display: flex; flex-direction: column">
            <step-progress
              :steps="mySteps"
              :current-step="currentStep"
              icon-class="fa fa-check fa-lg"
            ></step-progress>
            <div style="display: flex; flex-direction: row">
              <div v-if="getWidth <= 414" class="mobile-btn-exits">
                <div class="btn-exit">
                  <ButtonIcon
                    :iconUrl="'/icons/close.svg'"
                    :bgColor="`#ed8e91`"
                    :size="1"
                    @click="onClose"
                  />
                </div>
              </div>
              <div class="card">
                <div class="container_CAD01">
                  <div class="block">
                    <div v-if="getWidth > 414" class="btn-exit">
                      <ButtonIcon
                        :iconUrl="'/icons/close.svg'"
                        :bgColor="`#ed8e91`"
                        :size="1"
                        @click="onClose"
                      />
                    </div>
                    <div
                      style="display: flex; flex-direction: column"
                      v-for="(item, index) in message"
                      :key="index"
                    >
                      <div
                        :style="`display: flex;
                  justify-content: ${
                    item.position == 'left' || item.position == 'middle'
                      ? 'flex-start'
                      : 'flex-end'
                  };
                  margin-top: 5%;
                  `"
                      >
                        <div style="display: flex; align-items: center">
                          <div class="avatar">
                            <Avatar
                              :avatarUrl="baseUrl + item.picture.url"
                              v-show="item.position == 'left'"
                            />
                          </div>
                          <div
                            class="chat"
                            :style="`background-color:${
                              item.position == 'left' || item.position == 'middle' ? '#F2F2F2' : '#1E5BD7'
                            };
                  color: ${item.position == 'left' || item.position == 'middle' ? 'black' : 'white'}
                  `"
                          >
                            <div class="font_chat">
                              {{ checkLanguage(item.message) }}
                            </div>
                            <div
                              class="sound_img"
                              style="margin-top: 5%; margin-bottom: 5%"
                              v-if="item.sound != null"
                              @click="onPlay(index)"
                            >
                              <div class="btn_icon">
                                <div class="player" />
                                <img
                                  :src="soundbar"
                                  style="
                                    width: 60%;
                                    height: 100%;
                                    object-fit: contain;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <div class="avatar" v-show="item.position == 'right'">
                            <Avatar :avatarUrl="baseUrl + item.picture.url" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div
                        style="
                          display: flex;
                          justify-content: flex-end;
                          align-item: flex-end;
                          margin-right: 2.5%;
                        "
                      >
                        <div>
                          <div class="button" @click="nextMessage">
                            <div col="12">
                              <div style="font-size: 18px">NEXT</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonIcon from "@/components/elements/Buttons/ButtonIcon";
import Avatar from "@/components/elements/avatar/Avatar";
import LoadingMDL from "@/components/loading/LoadingMDL";
import { mapGetters } from "vuex";
import "../../assets/scss/chinessStyle2.scss";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";

export default {
  components: { ButtonIcon, Avatar, LoadingMDL, StepProgress },
  name: "CAD01",
  props: {},
  data() {
    return {
      soundbar: "/icons/sound.svg",
      language: "",
      baseUrl: process.env.VUE_APP_URL_SOUND,
      loading: true,
      content: [],
      navigate: "",
      message: [],
      soundObject: null,
      index_play: null,
      isPlay: false,
      getWidth: window.innerWidth,
      mySteps: [],
      currentStep: null,
      condition: [],
      startTime: "",
      criteria_id: "",
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code:"",
      section:"",
      chapter: null,
    };
  },
  methods: {
    onPlay: function (index) {
      //เช็คว่าเคยกดเล่นเสียงหรือยังถ้ายังจะให้ index ที่ส่งมา เก็บเข้าใน state
      if (this.index_play == null) {
        this.index_play = index;
      }
      //หยุดเล่นเสียงตำแหน่งเดิม
      if (this.index_play == index && this.isPlay) {
        //ถ้าใช่
        this.soundObject.pause();
        this.isPlay = false;
        return;
      }
      //เล่นเสียงตำแหน่งเดิม
      else if (
        this.index_play == index &&
        this.isPlay == false &&
        this.soundObject != null
      ) {
        this.soundObject.play();
        this.isPlay = true;
        return;
      }
      //หยุดเล่นเสียงก่อนหน้าและเล่นเสียงใหม่
      else if (this.soundObject != null && this.index_play != index) {
        this.soundObject.pause();
        this.isPlay = false;
        this.index_play = index;
      }
      this.soundObject = new Audio(
        "https://mdl.mfu.ac.th/" + this.content[index].sound.url
      );
      this.isPlay = true;
      this.soundObject.play();
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log("change language is error 1!!");
        }
      } else {
        console.log("change language is error 2!!");
      }
    },
    nextMessage: function () {
      let index_message = this.message.length;
      if (this.content.length == index_message) {
        this.commitUserProgress();
        return;
      }
      this.message.push(this.content[index_message]);
    },
    commitUserProgress: function () {
      this.loading = true;
      this.$store.dispatch("template/commitUserProgressChinese2", {
        code: this.code,
        contentId: this.criteria_id,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        topic: this.topic,
        chapter: this.chapter,
        condition: this.condition,
      });
    },
    onClose: function () {
      if (this.navigate.close.action != "") {
        var str = this.navigate.close.action.split("-");
        let body = "/" + str[0] + "/" + str[1];
        this.$router.push(body);
      }
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case "topic":
              this.mySteps.push("Topic");
              break;
            case "flipcard":
              this.mySteps.push("Vocabulary");
              break;
            case "assignment":
              this.mySteps.push("Assignment");
              break;
            case "test":
              this.mySteps.push("Test");
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: "template/getTemplateAndProgress",
      getResponseStatus: "template/getResponseStatus",
      storeLanguage: "language/getLanguage",
    }),
  },
  watch: {
    getTemplateAndProgress: async function (value) {
      this.mySteps = [];
      if (value.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: value.criteria.condition.criteriaType[0]._id,
          val: value.criteria.condition.criteriaType[0].val,
        });
      }
      this.criteria_id = value.criteria._id;
      this.chapter = value.chapter;
      this.topic = value.topicPosition;

      this.content = value.templateData.content.item;
      this.message.push(value.templateData.content.item[0]);
      this.navigate = value.templateData.navigate;
      await this.setProgress(value);
      this.loading = false;
    },
    getResponseStatus: function (value) {
      if (value.status == 200) {
        if (this.navigate.next.action != "") {
          var str = this.navigate.next.action.split("-");
          let body = "/" + str[0] + "/" + str[1];
          if (str[0] == this.$route.name) {
            this.content = [];
            this.message = [];
            this.soundObject = null;
            this.index_play = null;
            this.isPlay = false;
            this.getWidth = window.innerWidth;
            this.mySteps = [];
            this.currentStep = null;
            this.condition = [];
            this.startTime = "";
            this.criteria_id = "";
            this.topic = {};
            this.chapter = null;

            let payload = {
              templateCode: this.navigate.next.action,
              code: this.code,
              section:this.section
              // section: "testing",
            };
            this.$store.dispatch("template/fetchTemplateAndProgress", payload);
          }
          this.$router.push(body);
        }
      }
    },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    this.loading = true;
    this.language = this.$store.getters["language/getLanguage"];
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
  },
  mounted() {
    let payload = {
      templateCode: this.currentRoute,
      code: this.code,
      section:this.section
      // section: "testing",
    };
    this.$store.dispatch("template/fetchTemplateAndProgress", payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
::v-deep .step-progress__wrapper {
  width: 75%;
}
::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: grey !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}
::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}
::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}
::v-deep .step-progress__step span {
  font-size: 0px;
}
::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}
::v-deep .step-progress__step-label {
  top: -50px;
}
::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}
::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}
::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}
.LS01_background {
  background-color: #e6efff;
}
.btn_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
  padding-top: 0px;
  padding-bottom: 0px;
  object-fit: cover;
  border-radius: 8px !important;
  cursor: pointer;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 10%;
  padding-bottom: 15%;
}
.container_CAD01 {
  padding-left: 4%;
  padding-right: 4%;
}
.card {
  background-color: white;
  width: 900px;
  height: auto;
  margin-bottom: 12%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px; /* 5px rounded corners */
}
.block {
  //   background-color: #e6efff;
  width: 100%;
  border-radius: 7px;
}
.font_setting {
  padding: 20px 20px 20px 20px;
  color: #1d5bd7;
}
.chat {
  display: flex;
  height: auto;
  width: 100%;
  align-items: center;
  margin-bottom: 0;
  border-radius: 8px !important;
}
.font_chat {
  font-family: "KaiTi" !important;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 10px;
}
.icon_btn {
  line-height: 20px;
  vertical-align: center;
  background-image: url("/icons/play-arrow.svg")
    no-repeat;
  background-size: contain;
}
.button {
  padding: 8px 50px;
  margin-top: 10%;
  margin-bottom: 20%;
  background-color: #89abe6;
  color: white;
  font-size: 12px;
  border-radius: 8px !important;
  cursor: pointer;
}
* {
  user-select: none;
}
.btn-exit {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 98%;
  z-index: 90;
}
.container_CIT01 {
  margin-left: auto;
  margin-right: auto;
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1%;
}
.ContentProgressBar {
  // padding-left: 40%;
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }

  // .progress-bar {
  //     background-color: #b3b3b3 !important;
  // }
}

.progress-bar-striped {
  background-image: none !important;
}
/* Add rounded corners to the top left and the top right corner of the image */
.radius_img {
  width: 50px;
  position: absolute;
  height: 50px;
}
.text-center {
  height: 0;
  width: 0;
}
.avatar {
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  margin: 0 10px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .btn-exit {
    width: 50px;
    height: 50px;
    left: 85%;
  }
  ::v-deep .step-progress__step:after {
    width: 25px;
    height: 25px;
  }
  .position {
    flex-direction: column;
    align-items: center;
    padding-top: 20%;
  }
  .mobile-btn-exits {
    display: flex;
    justify-content: flex-end;
    height: 50px;
    // background-color: red;
  }
  .card {
    margin-top: 0;
    width: 300px;
  }
  .sound_img {
    display: flex;
    margin-top: 10%;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 30%;
    height: 30px;
  }
  .chat {
    display: flex;
    justify-content: space-around;
  }
  .font_chat {
    font-size: 20px;
    width: 70%;
    // background-color: chartreuse;
  }
}
// resolution ipad
@media only screen and (min-width: 600px) and (max-width: 1366px) {
  ::v-deep .step-progress__wrapper {
    width: 90%;
  }
  .btn-exit {
    width: 60px;
    height: 60px;
    left: 96%;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }
}
// PC MAX 1800
@media only screen and (min-width: 1366px) and (max-width: 1800px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }
}
// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
